import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {CustomObjectEditPageComponent} from "./custom-object-edit-page.component";
import {OutletCustomObjectEntityModel} from "../outlet-custom-object-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-outlet-custom-object-edit-page",
    templateUrl: "./custom-object-edit-page.component.html",
    providers: [provideEntityModel(OutletCustomObjectEntityModel)]
})
export class OutletCustomObjectEditPageComponent extends CustomObjectEditPageComponent {
    override outletContext: boolean = true;

    constructor(model: OutletCustomObjectEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(model, changeDetectorRef, responsiveService);
    }
}
